/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import { InvitationImport, InvitationsPage, InviteeResult } from '../../models';
import { ObservableResult } from '../../store';
import { InvitationsDataService, InvitedContent } from './invitations-data.service';

@Injectable()
export class MockInvitationsDataService implements InvitationsDataService {
  list(content: InvitedContent, page: number, size: number): ObservableResult<InvitationsPage> {
    return ObservableResult.ofSuccess({ content: [], totalNumberOfElement: 0, pageSize: size, currentPageNumber: page, counts: {} });
  }

  invite(content: InvitedContent, request: { userUids: string[]; emails: string[] }): ObservableResult<InviteeResult[]> {
    return ObservableResult.ofSuccess([]);
  }

  importCsv(content: InvitedContent, file: File): ObservableResult<InvitationImport> {
    return ObservableResult.ofSuccess({ invitees: [], invalidRows: [] });
  }

  resend(content: InvitedContent, invitationUid: string): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  remove(content: InvitedContent, invitationUid: string): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }
}
